// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GenerateAndSavePdfFromTemplateRequest {
    static getAttributeTypeMap() {
        return GenerateAndSavePdfFromTemplateRequest.attributeTypeMap;
    }
}
GenerateAndSavePdfFromTemplateRequest.discriminator = undefined;
GenerateAndSavePdfFromTemplateRequest.additionalProperties = false;
GenerateAndSavePdfFromTemplateRequest.attributeTypeMap = [
    {
        "name": "type",
        "baseName": "type",
        "type": "number"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GeneratePdfFromTemplateRequest"
    },
];
//# sourceMappingURL=generateAndSavePdfFromTemplateRequest.js.map